<template>
<v-container grid-list-xl fluid>
    <v-layout row wrap>
        <v-flex lg12 pb-0 v-if="orderbutton" class="hidden-sm-and-down">
            <div class="row group-box">
                <div class="col-md-2">
                    <a href="javascript: void(0)"
                        @click="onclickStatus({ value: -1, name: 'Tất cả', color: '#fff' })"
                        :class="{ 'active-status': selectedStatus === -1 }"
                        style="border-left-color: #bdc3d1"
                        class="btn btn-default btn-sm btn-block btn-status">
                        Tất cả<br/>({{getTotalOrder(-1, false)}})
                    </a>
                </div>
                <div class="col-md-8">
                    <div class="row">
                        <div class="col-md-4 pa-0 pl-2" v-for="status of listStatus" v-bind:key="status.value">
                            <a v-if="status.value != -2" href="javascript: void(0)"
                                :style="{ 'border-left-color': status.color }"
                                @click="onclickStatus(status)"
                                :class="{ 'active-status': selectedStatus === status.value }"
                                class="btn btn-default btn-sm btn-block btn-order-status">
                                {{ status.name }}
                                <span class="total">{{getTotalOrder(status.value)}}</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-md-2 pl-4">
                    <a  href="javascript: void(0)"
                        @click="onclickStatus({ value: 10, name: 'Hoàn thành', color: 'blue' })"
                        :class="{ 'active-status': selectedStatus === 10 }"
                        style="border-left-color: #7a8498"
                        class="btn btn-default btn-sm btn-block btn-status">
                        Hoàn thành<br/>({{getTotalOrder(10, false)}})
                    </a>
                </div>
            </div>        
        </v-flex>
        <v-flex lg12 pt-0 pb-4 :class="{ 'classic-search-wrapper': useClassicSearch }">
            <div v-if="useClassicSearch" class="rounded-lg search-bar classic-search-bar">
                <div class="classic-search-container">
                    <div v-for="column in classicHeaderConfigs" :key="column.value" class="classic-search-item">
                        <div class="classic-search-label">{{ column.text }}</div>
                        <v-select
                            v-if="column.dataType === dataTypes.Enum"
                            v-model="classicValues[column.value]"
                            :items="column.values || []"
                            item-value="value"
                            :item-text="p => p.i18n ? $t(p.i18n) : p.name"
                            :placeholder="column.text"
                            hide-details
                            clearable
                            outlined
                            dense
                            class="classic-control"
                            @change="onClassicFieldChange"
                        ></v-select>
                        <h-currency-input
                            v-else-if="column.dataType === dataTypes.Number"
                            v-model="classicValues[column.value]"
                            :decimal="column.decimal || 0"
                            :placeholder="column.text"
                            class="classic-control"
                            @press_enter="applyClassicSearch"
                        ></h-currency-input>
                        <div v-else-if="column.dataType === dataTypes.Date" class="classic-date-wrap">
                            <v-menu
                                v-model="classicDateMenus[column.value]"
                                offset-y
                                :close-on-content-click="false"
                                content-class="classic-date-menu-content"
                                transition="scale-transition"
                                min-width="290"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <div
                                        class="classic-date-field"
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        <v-icon class="classic-date-icon">event</v-icon>
                                        <span
                                            class="classic-date-text"
                                            :class="{ 'classic-date-placeholder': !hasClassicValue(column.value) }"
                                        >
                                            {{ formatClassicDateDisplay(column) }}
                                        </span>
                                        <button
                                            v-if="hasClassicValue(column.value)"
                                            type="button"
                                            class="classic-date-clear"
                                            @click.stop.prevent="clearClassicDate(column)"
                                        >
                                            ×
                                        </button>
                                    </div>
                                </template>
                                <v-date-picker
                                    :value="getClassicDatePickerValue(column.value)"
                                    no-title
                                    scrollable
                                    @input="setClassicDateValue(column, $event)"
                                ></v-date-picker>
                            </v-menu>
                        </div>
                        <v-text-field
                            v-else
                            v-model="classicValues[column.value]"
                            :placeholder="column.text"
                            hide-details
                            outlined
                            dense
                            class="classic-control"
                            @keyup.enter="applyClassicSearch"
                            @input="onClassicTextInput(column)"
                        ></v-text-field>
                    </div>
                </div>
            </div>
            <v-app-bar v-else flat dense color="white" class="rounded-lg old-search-bar">
                <template>
                    <v-text-field flat solo dense prepend-inner-icon="search" :placeholder="$t('actions.search')" v-model="quickSearchTerm" hide-details v-on:keyup.enter="quickSearchData" @input="clearQuickSearch" v-shortkey.focus="['alt', 'i']" background-color="transparent" class="flex-grow-1 mr-4" style="width: 100%;"></v-text-field>
                    <template v-for="(cond, index) in conditions">
                        <v-menu v-model="cond.menu" :key="index" :close-on-content-click="false" :nudge-width="200" offset-x v-if="refreshFilter" content-class="filter-menu-content" :z-index="999999">
                            <template v-slot:activator="{ on }">
                                <v-chip close class="ml-1" v-on="on" @click:close="removeFilter(cond)">{{conditionDisplay(cond)}}</v-chip>
                            </template>
                            <v-card>
                                <v-widget :title="cond.name">
                                    <div slot="widget-content">
                                        <v-select v-model="cond.selectedCondition" :items="cond.conditions" item-value="value" :item-text="p => p.i18n ? $t(p.i18n) : p.name"></v-select>
                                        <v-text-field v-model="cond.value" v-if="cond.dataType === dataTypes.String" @focus="true" @keyup.enter="advanceFilterData(cond)"></v-text-field>
                                        <h-currency-input v-model="cond.value" v-if="cond.dataType === dataTypes.Number" :decimal="cond.decimal" @focus="true" @press_enter="advanceFilterData(cond)"></h-currency-input>
                                        <v-select :chips="true" :multiple="true" :small-chips="true" :items="cond.listOfValue" v-model="cond.value" :item-text="p => p.i18n ? $t(p.i18n) : p.name" item-value="value" @focus="true" v-if="cond.dataType === dataTypes.Enum"></v-select>
                                        <datepicker v-model="cond.value" v-if="cond.dataType === dataTypes.Date" format="dd/MM/yyyy" @focus="true"></datepicker>
                                        <v-flex class="align-end">
                                            <v-btn @click="advanceFilterData(cond)">OK</v-btn>
                                            <v-btn @click="closePopup(cond)" class="ml-1">{{ $t('actions.cancel') }}</v-btn>
                                        </v-flex>
                                    </div>
                                </v-widget>
                            </v-card>
                        </v-menu>
                    </template>
                    <v-menu :close-on-content-click="false" v-model="filterMenu" :nudge-width="200" offset-x offset-y v-if="advanceFilterable" content-class="filter-menu-content" :z-index="999999">
                        <template v-slot:activator="{ on }">
                            <v-btn icon v-on="on">
                                <v-icon>filter_list</v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <template v-for="(item, index) in headers">
                                <v-list-item :key="index" v-if="item.filterable" @click="enterCondition(item.value)">
                                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                                </v-list-item>
                            </template>
                        </v-list>
                    </v-menu>
                </template>
            </v-app-bar>
        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
import configs from "@/configs";
import _ from "lodash";
import moment from "moment";
import VWidget from "@/components/VWidget";
import Datepicker from "vuejs-datepicker";
import {
    display_date
} from "@/commons/formater";
import {
    currency
} from "@/commons/currency";

export default {
    name: "filtering",
    filters: {},
    components: {
        VWidget,
        Datepicker
    },
    props: {
        headers: Array,
        viewName: String,
        orderbutton: Boolean,
        orderSummary: Object,
        listStatus: Array,
        view_filters: Array,
        classicSearch: {
            type: Boolean,
            default: false
        },
        classicColumns: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            show: true,
            selectedStatus: -1,
            filterMenu: false,
            selectedConditionValue: "",
            selected: [],
            comparions: configs.LIST_COMPARISON,
            dataTypes: configs.DATA_TYPE,
            quickSearchTerm: "",
            refreshFilter: true,
            classicValues: {},
            classicDateMenus: {},
        };
    },
    computed: {
        selectedCondition() {
            let conditions = [];
            let column = _.find(this.headers, {
                value: this.selectedConditionValue
            });
            if (column) {
                conditions = _.filter(this.comparions, {
                    dataType: column.dataType
                });
            }
            return conditions;
        },
        conditions: {
            get() {
                let filters = this.$store.state.commons.filters;
                return !_.isEmpty(filters) && !_.isEmpty(filters[this.viewName]) ?
                    filters[this.viewName] : [];
            },
            set(value) {
                let filters = this.$store.state.commons.filters || {};
                filters[this.viewName] = value;
                this.$store.commit("commons/setFilters", {
                    filter: filters
                });
            }
        },
        filterConditions: {
            get() {
                let filterConditions = this.$store.state.commons.filterConditions;
                return !_.isEmpty(filterConditions) ?
                    filterConditions[this.viewName] : [];
            },
            set(value) {
                let filterConditions = this.$store.state.commons.filterConditions || {};
                filterConditions[this.viewName] = value;
                this.$store.commit("commons/setFilterConditions", {
                    filter: filterConditions
                });
            }
        },
        advanceFilterable() {
            return _.find(this.headers, {'filterable': true}) != null;
        },
        isMobileView() {
            return this.$vuetify && this.$vuetify.breakpoint
                ? this.$vuetify.breakpoint.smAndDown
                : false;
        },
        useClassicSearch() {
            return this.classicSearch && !this.isMobileView;
        },
        classicHeaderConfigs() {
            if (!this.useClassicSearch || _.isEmpty(this.classicColumns)) {
                return [];
            }
            return this.classicColumns
                .map(columnName => _.find(this.headers, { value: columnName }))
                .filter(column => column && column.filterable);
        }
    },
    watch: {
        conditions: {
            handler() {
                this.getLastStatus();
                if (this.useClassicSearch) {
                    this.syncClassicValuesFromConditions();
                }
            },
            deep: true
        },
        view_filters() {
            if(this.view_filters && this.view_filters.length > 0) {
                this.conditions = [];
                let filters = this.view_filters;
                for (let i = 0; i < filters.length; i++) {
                    let column = _.find(this.headers, { value: filters[i].column });
                    if (column) {
                        if(column.values) {
                            _.each(column.values, itm => _.set(itm, 'disabled', false));
                        }
                        let condition_filters = _.filter(this.comparions, { dataType: column.dataType });
                        let condition = {
                            column: filters[i].column,
                            name: column.text,
                            value: filters[i].value,
                            menu: false,
                            decimal: column.decimal || 0,
                            dataType: column.dataType,
                            listOfValue: column.values,
                            conditions: condition_filters,
                            selectedCondition: filters[i].condition
                        };
                        this.conditions = _.concat(this.conditions, condition);
                    }
                }
                this.filterMenu = false;
                this.advanceFilterData();
            }
            else {
                this.conditions = []
                this.filterConditions = []
                this.filterMenu = false;
                this.advanceFilterData();
            }
        },
        classicSearch: {
            immediate: true,
            handler(value) {
                if (value && this.useClassicSearch) {
                    this.$emit("quickFilter", []);
                    this.syncClassicValuesFromConditions();
                }
            }
        },
        classicColumns() {
            if (this.useClassicSearch) {
                this.syncClassicValuesFromConditions();
            }
        },
        isMobileView(value) {
            if (!value && this.useClassicSearch) {
                this.$emit("quickFilter", []);
                this.syncClassicValuesFromConditions();
            }
        }
    },
    mounted() {
        this.conditions = []
        this.filterConditions = []
        this.getLastStatus();
    },
    methods: {
        getTotalOrder(status, format = true) {
            var total = 0;
            if(!this.orderSummary) {
                return 0;
            }
            switch (status) {
                case 0:
                    total = this.orderSummary.TotalStatus0;
                    break;
                case 1:
                    total = this.orderSummary.TotalStatus1;
                    break;
                case 2:
                    total = this.orderSummary.TotalStatus2;
                    break;
                case 5:
                    total = this.orderSummary.TotalStatus5;
                    break;
                case 7:
                    total = this.orderSummary.TotalStatus7;
                    break;
                case 8:
                    total = this.orderSummary.TotalStatus8;
                    break;
                case 9:
                    total = this.orderSummary.TotalStatus9;
                    break;
                case 10:
                    total = this.orderSummary.TotalStatus10;
                    break;
                case 13:
                    total = this.orderSummary.TotalStatus13;
                    break;
                case 16:
                    total = this.orderSummary.TotalStatus16;
                    break;
                default:
                    total = this.orderSummary.TotalStatusAll;
                    break;
            }

            if(total < 999 || !format) {
                return total.toLocaleString('en-US');
            }
            return (Math.floor(total / 1000, 0)).toLocaleString('en-US') + 'K';
        },
        enterCondition(item) {
            let column = _.find(this.headers, {
                value: item
            });
            let condition = {};
            if (column) {
                _.each(column.values, itm => _.set(itm, 'disabled', false));
                let condition_filters = _.filter(this.comparions, {
                    dataType: column.dataType
                });
                condition = {
                    column: item,
                    name: column.text,
                    value: column.dataType === configs.DATA_TYPE['Number'] ? 0 : "",
                    menu: false,
                    decimal: column.decimal || 0,
                    dataType: column.dataType,
                    listOfValue: column.values,
                    conditions: condition_filters,
                    selectedCondition: condition_filters[0].value
                };
                this.conditions = _.concat(this.conditions, condition);
            }
            this.selected = [];
            this.filterMenu = false;
            this.$nextTick(() => {condition.menu = true;});
        },
        conditionDisplay(cond) {
            const condition = _.find(this.comparions, {
                value: cond.selectedCondition
            });
            let displayValue = "";
            if (cond.value !== null && cond.value !== undefined && cond.value !== "") {
                switch (cond.dataType) {
                    case this.dataTypes.Date:
                        displayValue = display_date(cond.value, "DD/MM/YYYY");
                        break;
                    case this.dataTypes.Number:
                        displayValue = currency(cond.value, "", cond.decimal || 0);
                        break;
                    case this.dataTypes.Enum:
                        let listVals = _.split(cond.value, ",");
                        let displayVals = [];
                        for (let i = 0; i < cond.listOfValue.length; i++) {
                            const element = cond.listOfValue[i];
                            if (listVals.includes(element.value.toString())) {
                                displayVals.push(element.name);
                            }
                        }
                        displayValue = displayVals.join(", ");
                        break;
                    default:
                        displayValue = cond.value;
                        break;
                }
            }
            return (
                cond.name +
                " " +
                (condition ? condition.display.replace("{0}", displayValue) : "")
            );
        },
        removeFilter(condition) {
            _.remove(this.conditions, {
                column: condition.column
            });
            this.advanceFilterData();
            this.refreshFilterChips();
        },
        refreshFilterChips() {
            this.refreshFilter = false;
            setTimeout(() => {
                this.refreshFilter = true;
            }, 100);
        },
        getLastStatus() {
            const status = _.find(this.conditions, {'column': 'Status'});
            if(status && status.value.length > 0) {
                this.selectedStatus = status.value[0]
            }
        },
        onclickStatus(status) {
            this.selectedStatus = status.value;
            let column = _.find(this.headers, {
                value: 'Status'
            });
            let condition = {};
            if (column && this.selectedStatus !== -1) {
                _.each(column.values, itm => _.set(itm, 'disabled', false));
                let condition_filters = _.filter(this.comparions, {
                    dataType: column.dataType
                });
                condition = {
                    column: 'Status',
                    name: column.text,
                    value: [this.selectedStatus],
                    menu: false,
                    decimal: column.decimal || 0,
                    dataType: column.dataType,
                    listOfValue: column.values,
                    conditions: condition_filters,
                    selectedCondition: condition_filters[0].value
                };
                this.conditions = [condition];
            }
            else {
                this.conditions = [];
            }
            this.selected = [];
            this.filterMenu = false;
            this.advanceFilterData();
        },
        quickSearchData() {
            let quickConditions = [];
            if(this.quickSearchTerm != "") {
                for (let i = 0; i < this.headers.length; i++) {
                    const column = this.headers[i];
                    if ((column.dataType === configs.DATA_TYPE.String && column.quickSearch) || column.value === 'ID') {
                        let condition = {
                            column: column.value,
                            value: this.quickSearchTerm.trim(),
                            condition: "contain"
                        };
                        quickConditions = _.concat(quickConditions, condition);
                    }
                }
            }
            this.$emit("quickFilter", quickConditions);
        },
        clearQuickSearch() {
            if(this.quickSearchTerm == "") {
                this.$emit("quickFilter", []);
            }
        },
        getDefaultClassicValue(column) {
            if (!column) {
                return "";
            }
            switch (column.dataType) {
                case this.dataTypes.Enum:
                case this.dataTypes.Number:
                case this.dataTypes.Date:
                    return null;
                default:
                    return "";
            }
        },
        getClassicConditionValue(column, value) {
            if (value === null || value === undefined || value === "") {
                return null;
            }
            if (column.dataType === this.dataTypes.Enum) {
                return [value];
            }
            return value;
        },
        getClassicCondition(column, value) {
            const conditionValue = this.getClassicConditionValue(column, value);
            if (conditionValue === null) {
                return null;
            }
            let selectedCondition = "contain";
            if (column.dataType === this.dataTypes.Enum) {
                selectedCondition = "in";
            } else if (column.dataType === this.dataTypes.Number) {
                selectedCondition = "equal";
            } else if (column.dataType === this.dataTypes.Date) {
                selectedCondition = "d_equal";
            }
            return {
                column: column.value,
                name: column.text,
                value: conditionValue,
                menu: false,
                decimal: column.decimal || 0,
                dataType: column.dataType,
                listOfValue: column.values,
                conditions: _.filter(this.comparions, { dataType: column.dataType }),
                selectedCondition
            };
        },
        syncClassicValuesFromConditions() {
            const nextValues = {};
            _.each(this.classicHeaderConfigs, column => {
                const condition = _.find(this.conditions, { column: column.value });
                if (!condition) {
                    nextValues[column.value] = this.getDefaultClassicValue(column);
                    return;
                }
                if (column.dataType === this.dataTypes.Enum) {
                    const rawValue = _.isArray(condition.value) ? condition.value[0] : condition.value;
                    nextValues[column.value] = rawValue !== undefined ? rawValue : this.getDefaultClassicValue(column);
                    return;
                }
                nextValues[column.value] = condition.value;
            });
            this.classicValues = nextValues;
        },
        buildClassicConditions() {
            return this.classicHeaderConfigs.reduce((result, column) => {
                const condition = this.getClassicCondition(column, this.classicValues[column.value]);
                if (condition) {
                    result.push(condition);
                }
                return result;
            }, []);
        },
        hasClassicValue(columnName) {
            const value = this.classicValues[columnName];
            return value !== null && value !== undefined && value !== "";
        },
        formatClassicDateDisplay(column) {
            const value = this.classicValues[column.value];
            return this.hasClassicValue(column.value)
                ? display_date(value, "DD/MM/YYYY")
                : column.text;
        },
        getClassicDatePickerValue(columnName) {
            const value = this.classicValues[columnName];
            if (!this.hasClassicValue(columnName)) {
                return null;
            }
            return moment(value).format("YYYY-MM-DD");
        },
        applyClassicSearch() {
            this.conditions = this.buildClassicConditions();
            this.advanceFilterData();
        },
        clearClassicDate(column) {
            this.$set(this.classicValues, column.value, null);
            this.$set(this.classicDateMenus, column.value, false);
            this.applyClassicSearch();
        },
        setClassicDateValue(column, value) {
            this.$set(this.classicValues, column.value, value ? moment(value, "YYYY-MM-DD").toDate() : null);
            this.$set(this.classicDateMenus, column.value, false);
            this.applyClassicSearch();
        },
        onClassicFieldChange() {
            this.applyClassicSearch();
        },
        onClassicTextInput(column) {
            if (!this.classicValues[column.value]) {
                this.applyClassicSearch();
            }
        },
        advanceFilterData(cond) {
            this.closePopup(cond);
            const filter = _.map(this.conditions, obj => {
                obj.menu = false;
                return {
                    column: obj.column,
                    value: obj.value,
                    condition: obj.selectedCondition
                };
            });
            this.filterConditions = filter;
            this.$emit("applyFilter", filter);
            this.refreshFilterChips();
        },
        closePopup(cond) {
            if (cond) {
                cond.menu = false;
            }
            this.refreshFilterChips();
        }
    }
};
</script>

<style  lang="scss" scoped>
.btn {
    display: inline-block;
    margin-bottom: 0;
    font-weight: normal;
    text-align: center;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    border: 1px solid transparent;
    white-space: nowrap;
    padding: 10px 12px;
    font-size: 12px;
    line-height: 1.42857143;
    border-radius: 2px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.btn-default {
    color: #000000;
    background-color: #ffffff;
    border-color: #bdc3d1;
    text-decoration: none;
}
.btn-status {
    height: 87px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-left: 3px solid;
}
.btn-sm, .btn-group-sm > .btn {
    padding: 5px 8px;
    font-size: 11px;
    line-height: 1.5;
    border-radius: 2px;
}
.btn-block {
    width: 100%;
}
.btn-default:hover {
    color: #696c74;
    background-color: #ededed;
    border-color: #9fa8bc;
}
.btn-sm, .btn-group-sm > .btn {
    padding: 5px 8px 4px;
}
.btn-order-status {
    border-left: 3px solid;
    margin-bottom: 3px;
    span {
        float: right;
        text-align: right;
        border-left: 1px solid;
        border-color: #bdc3d1;
        width: 15%;
        height: 100%;
    }
}
.btn-m-status {
    border-left: 3px solid;
}
.group-box-mb {
    display: none;
    .group-status {
        width: 100%;
        background: #fff;
        border: 1px solid #d8dce3;
        box-shadow: none;
        .btn-toggle {
            width: 100%;
            color: #696c74;
        }
        .dropdown-menu {
            width: 100%;
        }
    }
}

.active-status {
    color: #ffffff;
    background-color: #3b4354;
    border-color: #3b4354;
    a:hover {
        color: #ffffff;
        background-color: #3b4354;
        border-color: #3b4354;
    }
    a {
        color: #ffffff;
    }
}
.divider {
    margin: 0px 0px;
}
.filter-text-box {
    margin-top: 15px;
    margin-bottom: 0px;
    .form-control {
        border: 0px;
        border-bottom: 1px solid #bdc3d1;
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
    }
}
.classic-search-bar {
    display: block;
    width: 100%;
    box-sizing: border-box;
    padding: 8px 16px 6px;
    background: #ffffff;
    overflow: visible;
    position: relative;
    z-index: 4;
}
.classic-search-container {
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-start;
    gap: 12px;
    width: 100%;
    padding: 0;
    margin: 0;
}
.classic-search-item {
    flex: 1 1 0px;
    min-width: 120px;
    align-self: flex-start;
    display: flex;
    flex-direction: column;
    gap: 4px;
}
.classic-search-label {
    min-height: 14px;
    padding: 0 12px;
    font-size: 12px;
    line-height: 14px;
    font-weight: 500;
    color: #747474;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.classic-control {
    width: 100%;
}
.classic-date-wrap {
    position: relative;
    width: 100%;
    display: block;
}
.classic-search-wrapper {
    padding-bottom: 8px !important;
}

@media (max-width: 992px) {
    .group-box-mb {
        display: block;
    }
    .group-box {
        display: none;
    }
}
</style>

<style lang="scss">
.old-search-bar {
    .v-toolbar__content {
        margin-top: 10px !important;
        align-items: center;
    }
    .v-input__prepend-inner,
    .v-input__icon,
    .v-icon {
        align-self: center !important;
        margin-top: 0 !important;
    }
    .v-text-field {
        margin-top: 0;
        padding-top: 0;
    }
    .v-chip {
        font-size: 12px !important;
        padding-right: 20px !important;
    }
}
.classic-search-bar {
    overflow: visible !important;
    .classic-control {
        .v-input__slot {
            min-height: 34px !important;
            height: 34px !important;
            border-radius: 10px !important;
            padding: 0 12px !important;
            align-items: center !important;
        }
        .v-text-field__slot,
        .v-select__slot {
            height: 100%;
            display: flex;
            align-items: center;
        }
        input {
            max-height: none !important;
            padding: 0 !important;
            line-height: 34px !important;
        }
        .v-select__selection {
            line-height: 20px !important;
            margin-top: 0 !important;
        }
        .v-input__append-inner,
        .v-input__icon,
        .v-icon {
            align-self: center !important;
            margin-top: 0 !important;
        }
        .v-input__append-inner {
            margin-top: 0 !important;
            padding-left: 8px;
        }
    }
    .classic-date-wrap {
        display: block;
    }
    input[type="number"] {
        -moz-appearance: textfield;
        appearance: textfield;
    }
    input[type="number"]::-webkit-outer-spin-button,
    input[type="number"]::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
}
.classic-date-field {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    height: 34px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 10px;
    background: #fff;
    padding: 0 36px 0 12px;
    cursor: pointer;
    box-sizing: border-box;
}
.classic-date-icon {
    font-size: 20px !important;
    color: #757575 !important;
    margin-right: 8px;
    transform: translateY(-7px) translateX(6px);
}
.classic-date-text {
    flex: 1;
    min-width: 0;
    color: rgba(0, 0, 0, 0.87);
    font-size: 14px;
    line-height: 34px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.classic-date-placeholder {
    color: rgba(0, 0, 0, 0.38);
}
.classic-date-clear {
    position: absolute;
    top: 50%;
    right: 8px;
    transform: translateY(-50%);
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 0;
    padding: 0;
    background: #e9edf2;
    color: #4f5965;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    text-align: center;
    cursor: pointer;
    z-index: 20;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08);
}
.classic-date-clear:focus {
    outline: none;
}
.classic-date-clear:hover {
    background: #dde3ea;
}
.classic-date-menu-content {
    z-index: 99999999 !important;
}
.v-toolbar__content .theme--light.v-label {
    color: rgb(116, 116, 116);
}
</style>
